import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Footer.scss';
import FooterLogo from '../../../assets/images/footer-logo.jpg';

class Footer extends Component {
  render() {
    return (
      <section id="footer">
        <div className="container large-container">
          <div className="row justify-content-between">
            <div className="col-lg-4 col-md-12 d-flex align-items-center">
              <div className="footer-logo">
                <img src={FooterLogo} alt="" />
              </div>
            </div>

            <div className="col-md-8 d-flex align-items-center justify-content-end">
              <div className="footer-nav text-right">
                <ul className="d-flex">
                  <li><a href="#">01 Home</a></li>
                  <li><a href="#below-banner">02 About</a></li>
                  <li><a href="#our-process">03 Process</a></li>
                  <li><a href="#we-have-worked-with">04 Our Customers</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default connect()(Footer);



// WEBPACK FOOTER //
// ./src/components/Common/Footer/Footer.js